module.exports = __webpack_public_path__ + "static/clinic-door-x2-d2abc66afb47002060477498bc045833.webp";